import styled from "styled-components";

const Icon = styled.img`
object-fit: contain;
width: ${props => props.size ? props.size : '55px'};`;

export default Icon;